// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage-showing-container {
  display: flex;
  width: 100%;
  flex-direction: column;
  font-family: "Proxima Nova", sans-serif;
}
.manage-showing-container .contents {
  margin-top: 60px;
  max-height: calc(100vh - 140px);
}
.manage-showing-container .select {
  display: flex;
  align-items: center;
  justify-content: center;
}
.manage-showing-container .select .queen-bee {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
  background-color: #FFF8E2;
  border-radius: 100px;
}
.manage-showing-container .select .queen-bee > img {
  height: 20px;
  width: 20px;
}
.manage-showing-container .time, .manage-showing-container .date {
  font-size: 12px;
  font-weight: 600;
  color: var(--secondary-color-1);
  flex-wrap: wrap;
  white-space: nowrap;
}
.manage-showing-container .time > p, .manage-showing-container .date > p {
  margin: 0;
}
.manage-showing-container .table-filters {
  display: flex;
}
.manage-showing-container .table-filters > div {
  align-items: center;
  display: flex;
  column-gap: 8px;
}
.manage-showing-container .table-filters > div .status {
  width: 150px;
  height: 42px;
  border-radius: 8px;
  background-color: #F9F9F9;
  display: flex;
  position: relative;
  cursor: pointer;
}
.manage-showing-container .table-filters > div .status.active {
  border-color: var(--primary-color-1);
}
.manage-showing-container .table-filters > div .status.type {
  width: 160px;
}
.manage-showing-container .table-filters > div .status.type > p {
  width: 160px;
}
.manage-showing-container .table-filters > div .status.type .status-menu.active {
  width: 160px;
}
.manage-showing-container .table-filters > div .status > p {
  text-transform: capitalize;
  color: #5F5F5F;
  font-size: 12px;
  font-weight: 600;
  margin: 0;
  padding-left: 43px;
  align-self: center;
  width: 180px;
  display: flex;
  align-items: center;
}
.manage-showing-container .table-filters > div .status > p::before {
  content: "";
  width: 16px;
  height: 16px;
  background-color: #D4D4D4;
  position: absolute;
  left: 20px;
  border-radius: 100%;
}
.manage-showing-container .table-filters > div .status > p.pending::before {
  background-color: #06C0CD;
}
.manage-showing-container .table-filters > div .status > p.rejected::before {
  background-color: #FF3535;
}
.manage-showing-container .table-filters > div .status > p.approved::before, .manage-showing-container .table-filters > div .status > p.upcoming::before {
  background-color: #357DED;
}
.manage-showing-container .table-filters > div .status > p.finished::before {
  background-color: #36C313;
}
.manage-showing-container .table-filters > div .status > p.cancelled::before {
  background-color: #484848;
}
.manage-showing-container .table-filters > div .status > p.ongoing::before {
  background-color: #CE1FFA;
}
.manage-showing-container .table-filters > div .status > p.listing::before {
  background-color: var(--primary-color-1);
}
.manage-showing-container .table-filters > div .status > p.buyer::before {
  background-color: #9E3645;
}
.manage-showing-container .table-filters > div .status > p.member::before {
  background-color: #527BA3;
}
.manage-showing-container .table-filters > div .status .status-menu {
  height: 0;
  opacity: 0;
  visibility: hidden;
  position: absolute;
  background-color: white;
  border-radius: 10px;
  left: 0;
  top: 62px;
  transition: 0.2s ease-in-out;
  text-transform: capitalize;
}
.manage-showing-container .table-filters > div .status .status-menu > p {
  opacity: 0;
  display: flex;
  align-items: center;
}
.manage-showing-container .table-filters > div .status .status-menu > p > span {
  height: 16px;
  width: 16px;
  margin-right: 10px;
  background-color: #D4D4D4;
  border-radius: 100%;
}
.manage-showing-container .table-filters > div .status .status-menu > p > span.pending {
  background-color: #06C0CD;
}
.manage-showing-container .table-filters > div .status .status-menu > p > span.rejected {
  background-color: #FF3535;
}
.manage-showing-container .table-filters > div .status .status-menu > p > span.approved {
  background-color: #357DED;
}
.manage-showing-container .table-filters > div .status .status-menu > p > span.finished {
  background-color: #36C313;
}
.manage-showing-container .table-filters > div .status .status-menu > p > span.cancelled {
  background-color: #484848;
}
.manage-showing-container .table-filters > div .status .status-menu > p > span.ongoing {
  background-color: #CE1FFA;
}
.manage-showing-container .table-filters > div .status .status-menu > p > span.listing {
  background-color: var(--primary-color-1);
}
.manage-showing-container .table-filters > div .status .status-menu > p > span.buyer {
  background-color: #9E3645;
}
.manage-showing-container .table-filters > div .status .status-menu > p > span.member {
  background-color: #527BA3;
}
.manage-showing-container .table-filters > div .status .status-menu.active {
  opacity: 1;
  visibility: visible;
  width: 200px;
  height: auto;
  z-index: 99;
}
.manage-showing-container .table-filters > div .status .status-menu.active > p {
  opacity: 1;
  padding-left: 20px;
  color: var(--secondary-color-2);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
.manage-showing-container .table-filters > div .status .status-menu.active > p.active {
  color: var(--primary-color-1);
}
.manage-showing-container .table-filters > div .status .status-menu.active > p:hover {
  color: var(--secondary-color-1);
}
.manage-showing-container .table-filters > div .date::-webkit-calendar-picker-indicator {
  display: none !important;
}
.manage-showing-container .table-filters > div .time {
  display: flex;
  align-items: center;
}
.manage-showing-container .table-filters > div .time > p {
  font-size: 16px;
  font-weight: 500;
  color: var(--secondary-color-2);
  margin: 0 20px;
}
.manage-showing-container .table-filters > div .time > input {
  width: 160px;
}
.manage-showing-container .tab-choice {
  display: flex;
  border-radius: 8px;
  overflow: hidden;
}
.manage-showing-container .tab-choice > li {
  background-color: #F9F9F9;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.2s ease-in-out;
}
.manage-showing-container .tab-choice > li:hover {
  opacity: 0.75;
}
.manage-showing-container .tab-choice > li.active {
  background-color: var(--primary-color-1);
}
.manage-showing-container .tab-choice > li.active > p {
  color: white;
  font-weight: 600;
}
.manage-showing-container .tab-choice > li > p {
  font-weight: 400;
  font-size: 12px;
  color: #5F5F5F;
  padding: 0 20px;
  margin: 0;
  display: block;
}
.manage-showing-container .tab-choice > li svg {
  display: none;
}
.manage-showing-container p.showing-status {
  font-weight: 700;
  color: var(--secondary-color-1);
  font-size: 14px;
}
.manage-showing-container p.showing-status.all {
  color: var(--primary-color-1);
}
.manage-showing-container p.showing-status.upcoming {
  color: #357DED;
}
.manage-showing-container p.showing-status.pending, .manage-showing-container p.showing-status.requested {
  color: #06C0CD;
}
.manage-showing-container p.showing-status.draft {
  color: #E49510;
}
.manage-showing-container p.showing-status.rejected {
  color: #FF3535;
}
.manage-showing-container p.showing-status.ongoing {
  color: #CE1FFA;
}
.manage-showing-container p.showing-status.approved {
  color: #357DED;
}
.manage-showing-container p.showing-status.finished {
  color: #36C313;
}
.manage-showing-container p.showing-status.cancelled {
  color: #484848;
}
.manage-showing-container .pagination {
  display: flex;
  align-items: center;
  column-gap: 16px;
}
.manage-showing-container .pagination > p {
  cursor: pointer;
  font-family: "Proxima Nova", sans-serif;
  font-size: 12px;
  font-weight: 760;
  color: #949494;
}
.manage-showing-container .pagination > p:hover {
  opacity: 0.75;
}
.manage-showing-container .pagination > p.next {
  text-align: right;
}
.manage-showing-container .pagination > ul {
  display: flex;
  font-family: "Proxima Nova", sans-serif;
}
.manage-showing-container .pagination > ul > li {
  cursor: pointer;
  font-weight: 700;
  color: var(--secondary-color-3);
  font-size: 18px;
}
.manage-showing-container .pagination > ul > li:hover {
  opacity: 0.75;
}
.manage-showing-container .pagination > ul > li.active {
  color: var(--secondary-color-1);
  text-decoration: underline;
}
.manage-showing-container .loader {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.863);
  z-index: 2;
  display: flex;
}

@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .manage-showing-container {
    width: 100%;
  }
  .manage-showing-container .table-filters div > div:first-child {
    display: none;
  }
}
@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .manage-showing-container {
    width: 100%;
  }
  .manage-showing-container .tab-choice li {
    padding: 10px;
  }
  .manage-showing-container .tab-choice li svg {
    display: block;
  }
  .manage-showing-container .tab-choice li p {
    display: none;
  }
  .manage-showing-container .table-filters div > div:first-child {
    display: none;
  }
  .manage-showing-container .table-filters > div .status {
    width: 130px;
  }
  .manage-showing-container .table-filters div.status.type {
    display: none;
  }
  .manage-showing-container button.custom-button .icon-left {
    margin-right: 0px;
    width: auto;
  }
  .manage-showing-container button.custom-button > p {
    display: none !important;
  }
  .manage-showing-container .time, .manage-showing-container .status-wrapper, .manage-showing-container .users-wrapper {
    display: flex;
    justify-content: flex-end;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/AgentDashboard/modules/ManageShowings/manageShowings.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,WAAA;EACA,sBAAA;EACA,uCAAA;AADJ;AAEI;EACI,gBAAA;EACA,+BAAA;AAAR;AAEI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AAAR;AACQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,oBAAA;AACZ;AAAY;EACI,YAAA;EACA,WAAA;AAEhB;AAEI;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;EACA,mBAAA;AAAR;AACQ;EAAM,SAAA;AAEd;AAAI;EACI,aAAA;AAER;AADQ;EACI,mBAAA;EACA,aAAA;EACA,eAAA;AAGZ;AAFY;EACI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AAIhB;AAHgB;EAAW,oCAAA;AAM3B;AALgB;EACI,YAAA;AAOpB;AANoB;EAAM,YAAA;AAS1B;AARoB;EACI,YAAA;AAUxB;AANgB;EACI,0BAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAQpB;AAPoB;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;AASxB;AAPoB;EAAoB,yBAAA;AAUxC;AAToB;EAAqB,yBAAA;AAYzC;AAXoB;EAAyC,yBAAA;AAc7D;AAboB;EAAqB,yBAAA;AAgBzC;AAfoB;EAAsB,yBAAA;AAkB1C;AAjBoB;EAAoB,yBAAA;AAoBxC;AAnBoB;EAAoB,wCAAA;AAsBxC;AArBoB;EAAkB,yBAAA;AAwBtC;AAvBoB;EAAmB,yBAAA;AA0BvC;AAxBgB;EACI,SAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,OAAA;EACA,SAAA;EACA,4BAAA;EACA,0BAAA;AA0BpB;AAzBoB;EACI,UAAA;EACA,aAAA;EACA,mBAAA;AA2BxB;AA1BwB;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AA4B5B;AA3B4B;EAAY,yBAAA;AA8BxC;AA7B4B;EAAa,yBAAA;AAgCzC;AA/B4B;EAAa,yBAAA;AAkCzC;AAjC4B;EAAa,yBAAA;AAoCzC;AAnC4B;EAAc,yBAAA;AAsC1C;AArC4B;EAAY,yBAAA;AAwCxC;AAvC4B;EAAY,wCAAA;AA0CxC;AAzC4B;EAAU,yBAAA;AA4CtC;AA3C4B;EAAW,yBAAA;AA8CvC;AA3CoB;EACI,UAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AA6CxB;AA5CwB;EACI,UAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AA8C5B;AA7C4B;EAAW,6BAAA;AAgDvC;AA/C4B;EACI,+BAAA;AAiDhC;AA1CgB;EACI,wBAAA;AA4CpB;AAzCY;EACI,aAAA;EACA,mBAAA;AA2ChB;AA1CgB;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,cAAA;AA4CpB;AA1CgB;EAAU,YAAA;AA6C1B;AAzCI;EACI,aAAA;EACA,kBAAA;EACA,gBAAA;AA2CR;AA1CQ;EACI,yBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,4BAAA;AA4CZ;AA3CY;EACI,aAAA;AA6ChB;AA3CY;EACI,wCAAA;AA6ChB;AA5CgB;EACI,YAAA;EACA,gBAAA;AA8CpB;AA3CY;EACI,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,SAAA;EACA,cAAA;AA6ChB;AA3CY;EACI,aAAA;AA6ChB;AAzCI;EACI,gBAAA;EACA,+BAAA;EACA,eAAA;AA2CR;AA1CQ;EAAQ,6BAAA;AA6ChB;AA5CQ;EAAa,cAAA;AA+CrB;AA9CQ;EAAyB,cAAA;AAiDjC;AAhDQ;EAAU,cAAA;AAmDlB;AAlDQ;EAAa,cAAA;AAqDrB;AApDQ;EAAY,cAAA;AAuDpB;AAtDQ;EAAa,cAAA;AAyDrB;AAxDQ;EAAa,cAAA;AA2DrB;AA1DQ;EAAc,cAAA;AA6DtB;AA3DI;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;AA6DR;AA5DQ;EACI,eAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AA8DZ;AA7DY;EAAU,aAAA;AAgEtB;AA/DY;EAAS,iBAAA;AAkErB;AAhEQ;EACI,aAAA;EACA,uCAAA;AAkEZ;AAjEY;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;AAmEhB;AAlEgB;EAAU,aAAA;AAqE1B;AApEgB;EACI,+BAAA;EACA,0BAAA;AAsEpB;AAjEI;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,4CAAA;EACA,UAAA;EACA,aAAA;AAmER;;AChTY;EDkPR;IACI,WAAA;EAkEN;EAhEU;IACI,aAAA;EAkEd;AACF;AChUY;EDsQR;IACI,WAAA;EA6DN;EA3DU;IACI,aAAA;EA6Dd;EA5Dc;IACI,cAAA;EA8DlB;EA5Dc;IAAI,aAAA;EA+DlB;EA3DU;IACI,aAAA;EA6Dd;EA1Dc;IACI,YAAA;EA4DlB;EAzDU;IACI,aAAA;EA2Dd;EAvDU;IACI,iBAAA;IACA,WAAA;EAyDd;EAvDU;IAAM,wBAAA;EA0DhB;EAxDM;IACI,aAAA;IACA,yBAAA;EA0DV;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\r\n\r\n.manage-showing-container {\r\n    display: flex;\r\n    width: 100%;\r\n    flex-direction: column;\r\n    font-family: \"Proxima Nova\", sans-serif;\r\n    .contents {\r\n        margin-top: 60px;\r\n        max-height: calc(100vh - 140px);\r\n    }\r\n    .select {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        .queen-bee {\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            height: 40px;\r\n            width: 40px;\r\n            background-color: #FFF8E2;\r\n            border-radius: 100px;\r\n            > img {\r\n                height: 20px;\r\n                width: 20px;\r\n            }\r\n        }\r\n    }\r\n    .time, .date {\r\n        font-size: 12px;\r\n        font-weight: 600;\r\n        color: var(--secondary-color-1);\r\n        flex-wrap: wrap;\r\n        white-space: nowrap;\r\n        > p { margin: 0 }\r\n    }\r\n    .table-filters {\r\n        display: flex;\r\n        > div {\r\n            align-items: center;\r\n            display: flex;\r\n            column-gap: 8px;\r\n            .status {\r\n                width: 150px;\r\n                height: 42px;\r\n                border-radius: 8px;\r\n                background-color: #F9F9F9;\r\n                display: flex;\r\n                position: relative;\r\n                cursor: pointer;\r\n                &.active { border-color: var(--primary-color-1); }\r\n                &.type {\r\n                    width: 160px;\r\n                    > p { width: 160px;}\r\n                    .status-menu.active {\r\n                        width: 160px;\r\n                    }\r\n        \r\n                }\r\n                > p {\r\n                    text-transform: capitalize;\r\n                    color: #5F5F5F;\r\n                    font-size: 12px;\r\n                    font-weight: 600;\r\n                    margin: 0;\r\n                    padding-left: 43px;\r\n                    align-self: center;\r\n                    width: 180px;\r\n                    display: flex;\r\n                    align-items: center;\r\n                    &::before {\r\n                        content: \"\";\r\n                        width: 16px;\r\n                        height: 16px;\r\n                        background-color: #D4D4D4;\r\n                        position: absolute;\r\n                        left: 20px;\r\n                        border-radius: 100%;\r\n                    }\r\n                    &.pending::before { background-color: #06C0CD; }\r\n                    &.rejected::before { background-color: #FF3535; }\r\n                    &.approved::before, &.upcoming::before { background-color: #357DED; }\r\n                    &.finished::before { background-color: #36C313; }\r\n                    &.cancelled::before { background-color: #484848; }\r\n                    &.ongoing::before { background-color: #CE1FFA; }\r\n                    &.listing::before { background-color: var(--primary-color-1); }\r\n                    &.buyer::before { background-color: #9E3645; }\r\n                    &.member::before { background-color: #527BA3; }\r\n                }\r\n                .status-menu {\r\n                    height: 0;\r\n                    opacity: 0;\r\n                    visibility: hidden;\r\n                    position: absolute;\r\n                    background-color: white;\r\n                    border-radius: 10px;\r\n                    left: 0;\r\n                    top: 62px;\r\n                    transition: .2s ease-in-out;\r\n                    text-transform: capitalize;\r\n                    > p { \r\n                        opacity: 0; \r\n                        display: flex;\r\n                        align-items: center;\r\n                        > span {\r\n                            height: 16px;\r\n                            width: 16px;\r\n                            margin-right: 10px;\r\n                            background-color: #D4D4D4;\r\n                            border-radius: 100%;\r\n                            &.pending { background-color: #06C0CD; }\r\n                            &.rejected { background-color: #FF3535; }\r\n                            &.approved { background-color: #357DED; }\r\n                            &.finished { background-color: #36C313; }\r\n                            &.cancelled { background-color: #484848; }\r\n                            &.ongoing { background-color: #CE1FFA; }\r\n                            &.listing { background-color: var(--primary-color-1); }\r\n                            &.buyer { background-color: #9E3645; }\r\n                            &.member { background-color: #527BA3; }\r\n                        }\r\n                    }\r\n                    &.active {\r\n                        opacity: 1;\r\n                        visibility: visible;\r\n                        width: 200px;\r\n                        height: auto;\r\n                        z-index: 99;\r\n                        > p {\r\n                            opacity: 1;\r\n                            padding-left: 20px;\r\n                            color: var(--secondary-color-2);\r\n                            font-size: 12px;\r\n                            font-weight: 600;\r\n                            cursor: pointer;\r\n                            &.active { color: var(--primary-color-1); }\r\n                            &:hover {\r\n                                color: var(--secondary-color-1);\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n            .date { \r\n                &::-webkit-calendar-picker-indicator {\r\n                    display: none !important;\r\n                }\r\n            }\r\n            .time {\r\n                display: flex;\r\n                align-items: center;\r\n                > p {\r\n                    font-size: 16px;\r\n                    font-weight: 500;\r\n                    color: var(--secondary-color-2);\r\n                    margin: 0 20px;\r\n                }\r\n                > input { width: 160px; }\r\n            }\r\n        }\r\n    }\r\n    .tab-choice {\r\n        display: flex;\r\n        border-radius: 8px;\r\n        overflow: hidden;\r\n        > li {\r\n            background-color: #F9F9F9;\r\n            height: 32px;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            cursor: pointer;\r\n            transition: .2s ease-in-out;\r\n            &:hover {\r\n                opacity: .75;\r\n            }\r\n            &.active {\r\n                background-color: var(--primary-color-1);\r\n                > p {\r\n                    color: white;\r\n                    font-weight: 600;\r\n                }\r\n            }\r\n            > p {\r\n                font-weight: 400;\r\n                font-size: 12px;\r\n                color: #5F5F5F;\r\n                padding: 0 20px;\r\n                margin: 0;\r\n                display: block;\r\n            }\r\n            svg {\r\n                display: none;\r\n            }\r\n        }\r\n    }\r\n    p.showing-status {\r\n        font-weight: 700;\r\n        color: var(--secondary-color-1);\r\n        font-size: 14px;\r\n        &.all { color: var(--primary-color-1); }\r\n        &.upcoming { color: #357DED; }\r\n        &.pending, &.requested { color: #06C0CD; }\r\n        &.draft { color: #E49510; }\r\n        &.rejected { color: #FF3535 }\r\n        &.ongoing { color: #CE1FFA; }\r\n        &.approved { color: #357DED; }\r\n        &.finished { color: #36C313; }\r\n        &.cancelled { color: #484848; }\r\n    }\r\n    .pagination {\r\n        display: flex;\r\n        align-items: center;\r\n        column-gap: 16px;\r\n        > p {\r\n            cursor: pointer;\r\n            font-family: 'Proxima Nova', sans-serif;  \r\n            font-size: 12px;\r\n            font-weight: 760;\r\n            color: #949494;\r\n            &:hover { opacity: .75; }\r\n            &.next { text-align: right; }\r\n        }\r\n        > ul {\r\n            display: flex;\r\n            font-family: 'Proxima Nova', sans-serif;  \r\n            > li { \r\n                cursor: pointer;\r\n                font-weight: 700;\r\n                color: var(--secondary-color-3);\r\n                font-size: 18px;\r\n                &:hover { opacity: .75; }\r\n                &.active {\r\n                    color: var(--secondary-color-1);\r\n                    text-decoration: underline;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .loader {\r\n        position: absolute;\r\n        left: 0;\r\n        right: 0;\r\n        top: 0;\r\n        bottom: 0;\r\n        background-color: rgba(255, 255, 255, 0.863);\r\n        z-index: 2;\r\n        display: flex;\r\n    }\r\n}\r\n\r\n@include media(tablet) {\r\n    .manage-showing-container {\r\n        width: 100%;\r\n        .table-filters {\r\n            div > div:first-child {\r\n                display: none;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n\r\n@include media(mobile) {\r\n    .manage-showing-container {\r\n        width: 100%;\r\n        .tab-choice {\r\n            li {\r\n                padding: 10px;\r\n                svg {\r\n                    display: block;\r\n                }\r\n                p { display: none; }\r\n            }\r\n        }\r\n        .table-filters {\r\n            div > div:first-child {\r\n                display: none;\r\n            }\r\n            > div {\r\n                .status {\r\n                    width: 130px;\r\n                }\r\n            }\r\n            div.status.type {\r\n                display: none;\r\n            }\r\n        }\r\n        button.custom-button {\r\n            .icon-left {\r\n                margin-right: 0px;\r\n                width: auto;\r\n            }\r\n            > p { display: none !important; }\r\n        }\r\n        .time, .status-wrapper, .users-wrapper {\r\n            display: flex;\r\n            justify-content: flex-end;\r\n        }\r\n    }\r\n}\r\n\r\n","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
